import { common } from '../common.js';
import type { IProgram } from '../types.js';


/** Visitor visa (temporary resident visa) from outside Canada. */
export const VISITOR_VISA: IProgram = {
  id: 'visitor-visa',
  name: 'Visitor visa (temporary resident visa)',
  short: 'Visitor visa',
  family: 'temporary',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: Apply for a visitor visa', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/apply-visitor-visa.html', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'invited', text: 'Is someone in Canada inviting the applicant?', kind: 'yesno' },
    { id: 'family', text: 'Is the person inviting them a family member?', kind: 'yesno' }
  ],
  roles: [
    { id: 'principal', label: 'Applicant', min: 1, max: 1 },
    { id: 'dependant', label: 'Family member travelling with them', min: 0, max: 10 }
  ],
  sections: ['Forms', 'Identity and civil documents', 'Purpose and ties', 'Funds', 'Photos and police certificates', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC personalized document checklist (from the IRCC portal or APR portal)', section: 'Forms', forRoles: 'application', source: 0 },
    common.representative(0),
    common.passport(0, ['principal', 'dependant']),
    { id: 'purpose', label: 'Purpose of the visit: travel plans, flight details, accommodation, event registration', section: 'Purpose and ties', forRoles: 'application', source: 0 },
    { id: 'invitation', label: 'Letter of invitation', section: 'Purpose and ties', forRoles: 'application', when: { q: 'invited', is: true }, source: 0 },
    { id: 'relationship', label: 'Proof of the relationship to the family member inviting them (marriage or birth certificate, IMM 5409)', section: 'Purpose and ties', forRoles: 'application', when: { all: [{ q: 'invited', is: true }, { q: 'family', is: true }] }, source: 0, translationIfNotEnFr: true },
    { id: 'ties', label: 'Ties to home: job, home, financial assets or family that will take them back', section: 'Purpose and ties', forRoles: ['principal'], source: 0 },
    { id: 'funds', label: 'Proof of financial support for the stay', section: 'Funds', forRoles: ['principal'], source: 0 },
    common.photos(0, ['principal', 'dependant']),
    common.translations(0),
    common.fees(0)
  ],
  deadlines: []
};

/** Extending a stay in Canada as a visitor (visitor record), or restoring visitor status. */
export const VISITOR_RECORD: IProgram = {
  id: 'visitor-record',
  name: 'Visitor record (extend a stay) or restoration of visitor status',
  short: 'Visitor record',
  family: 'temporary',
  status: 'active',
  maintainedStatus: true,
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: Extend your stay in Canada', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/extend-stay.html', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'restoration', text: 'Has the status already expired (restoration, within 90 days)?', kind: 'yesno' }
  ],
  roles: [{ id: 'principal', label: 'Applicant', min: 1, max: 1 }, { id: 'dependant', label: 'Family member', min: 0, max: 10 }],
  sections: ['Forms', 'Identity and civil documents', 'Purpose and ties', 'Funds', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC personalized document checklist (from the IRCC portal or APR portal)', section: 'Forms', forRoles: 'application', source: 0 },
    common.representative(0),
    common.passport(0, ['principal', 'dependant']),
    { id: 'currentStatus', label: 'Current or last status document (entry stamp, visitor record, permit)', section: 'Identity and civil documents', forRoles: ['principal', 'dependant'], source: 0 },
    { id: 'reason', label: 'Why they need to stay longer, and their plans to leave', section: 'Purpose and ties', forRoles: 'application', source: 0 },
    { id: 'restorationReason', label: 'Explanation of why the status expired (restoration)', section: 'Purpose and ties', forRoles: 'application', when: { q: 'restoration', is: true }, source: 0 },
    { id: 'funds', label: 'Proof of financial support for the longer stay', section: 'Funds', forRoles: ['principal'], source: 0 },
    { id: 'fees', label: 'Proof of payment of the fees (and the restoration fee, if it applies)', section: 'Fees', forRoles: 'application', source: 0 }
  ],
  deadlines: []
};
